//  For each product on the page
document.querySelectorAll(".product").forEach((section) => {
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(
        section.querySelector(".activeVariantJSON").textContent
    );
    let quantity = 1;

    /************
     Product Swiper
     ************/

    const swiperOptions = {
        slidesPerView: 1,
        // loop: true,
        autoplay: {delay: 5000, disableOnInteraction: false},
        initialSlide: 1,
        on: {
            init: function () {
                // set initial active pagination color to product color
                section
                    .querySelectorAll(".swiper-pagination-bullet")
                    ?.forEach((element) => {
                        if (element.classList.contains("swiper-pagination-bullet-active")) {
                            element.style.backgroundColor = element
                                .closest(".swiper-pagination")
                                ?.getAttribute("data-color");
                        } else {
                            element.style.backgroundColor = "#FFFAF0";
                        }
                    });
            },
            slideChange: function () {
                if (!section.querySelector(".productVisualSwiperSlide")) {
                    return;
                }
                // set pagination color to product color
                section
                    .querySelectorAll(".swiper-pagination-bullet")
                    ?.forEach((element) => {
                        if (element.classList.contains("swiper-pagination-bullet-active")) {
                            element.style.backgroundColor = element
                                .closest(".swiper-pagination")
                                ?.getAttribute("data-color");
                        } else {
                            element.style.backgroundColor = "#FFFAF0";
                        }
                    });
            },
        },
    };

    const multipleSwipers = section.querySelector(".productVisual.multiple");

    // setup product swiper/s
    if (multipleSwipers) {
        section
            .querySelectorAll(".productVisualSwiper")
            .forEach(async (element) => {
                const productSwiper = await new Swiper(element, {
                    ...swiperOptions,
                    navigation: {
                        nextEl: element.querySelector(".productVisualSwiperNext"),
                        prevEl: element.querySelector(".productVisualSwiperPrev"),
                    },
                    pagination: {
                        el: element.querySelector(".swiper-pagination"),
                    },
                });
            });
    } else {
        // setup single swiper
        const productSwiper = new Swiper(
            section.querySelector(".productVisualSwiper"),
            {
                ...swiperOptions,

                navigation: {
                    nextEl: section.querySelector(".productVisualSwiperNext"),
                    prevEl: section.querySelector(".productVisualSwiperPrev"),
                },
                pagination: {
                    el: section.querySelector(".swiper-pagination"),
                },
            }
        );
    }

    /**************
     Update Product
     ***************/

    section.querySelectorAll(".product input").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct().catch((e) => console.error(e));
        });
    });

    async function updateProduct() {
        // variables to check if elements exist
        let productATCExists = section.querySelector(".productATC") || false;
        let sellingPlanExists = section.querySelector(".productSelling") || false;

        const activeVariant = getActiveVariant();
        const activeVariantATC = getActiveVariantForATC();

        // check if variant wasn't found
        if (!activeVariantATC) {
            section.querySelector(".productATCButton").disabled = true;
            section.querySelector(".productATCButton").textContent = "Not Available";
            return;
        }

        if (multipleSwipers) {
            // hide existing active
            section.querySelector(".productVisualSwiper.active")?.classList.remove("active");
            // reveal matching media
            section.querySelector(`.productVisualSwiper.${activeVariant.option1}`).classList.add("active");
            section.querySelector(`.productVisualSwiper.${activeVariant.option1}`).swiper.slideTo(0);
        }

        // Change the color of the labels
        document
            .querySelectorAll(".productQuantityValuesLabelInput")
            .forEach(function (element) {
                const isChecked = element.checked;
                const variantColors = document.querySelector(
                    '.productOptionItemValuesLabelInput[name="flavor"]:checked'
                )?.dataset.color;
                const bgColor = variantColors
                    ? variantColors.split("/")[0]
                    : element.getAttribute("data-color");
                const textColor = variantColors
                    ? variantColors.split("/")[1]
                    : element.getAttribute("data-textColor");
                const neighbor = element.nextElementSibling;

                neighbor.style.backgroundColor = isChecked ? bgColor : "";
                neighbor.style.color = isChecked ? textColor : "#000901";
                if (
                    neighbor.querySelector(
                        ".productQuantityValuesLabelSelectorComparePrice"
                    )
                ) {
                    bgColor === "#ffffff" || bgColor === "#fffaf0"
                        ? (neighbor.querySelector(
                            ".productQuantityValuesLabelSelectorComparePrice"
                        ).style.color = "#000901")
                        : (neighbor.querySelector(
                            ".productQuantityValuesLabelSelectorComparePrice"
                        ).style.color = "#fffaf0");
                }
            });

        /**************
         Selling Plan
         ***************/

        if (sellingPlanExists) {
            let activeVariantPlan = activeVariant.selling_plan_allocations[0];

            // find the correct selling_plan_allocation
            for (let plan of activeVariant.selling_plan_allocations) {
                if (
                    plan.selling_plan_id ===
                    parseInt(
                        section.querySelector(
                            ".productSellingLabelBodyBottomWrapContentLabelInput:checked"
                        ).value
                    )
                ) {
                    activeVariantPlan = plan;
                }
            }

            // update savings text
            let save = (1 - activeVariantPlan.price / activeVariant.price) * 100;
            section.querySelector(".productSellingLabelBodyTopTitle").textContent =
                `Subscribe & Save ` + save.toFixed(0) + `%`;

            // save parent elements
            const once = section.querySelector(".productSellingLabelBody.once");
            const sub = section.querySelector(".productSellingLabelBody.sub");

            // update compare at price
            once.querySelector(".productSellingLabelBodyPriceCompare").textContent =
                "";
            sub.querySelector(".productSellingLabelBodyPriceCompare").textContent =
                price(activeVariantPlan.compare_at_price * quantity, true);
            if (activeVariant.compare_at_price > activeVariant.price) {
                once.querySelector(".productSellingLabelBodyPriceCompare").textContent =
                    price(activeVariant.compare_at_price * quantity, true);
            }

            // update actual price
            once.querySelector(".productSellingLabelBodyPriceReal").textContent =
                price(activeVariant.price * quantity, true);
            sub.querySelector(".productSellingLabelBodyPriceReal").textContent =
                price(activeVariantPlan.price * quantity, true);

            // update price outside of selling plan module if selling plan is selected
            if (
                section.querySelector(".productSellingLabelInput:checked")?.value ===
                "sub"
            ) {
                section.querySelector(".productPriceReal").textContent = price(
                    activeVariantPlan.price * quantity
                );
                section.querySelector(".productPriceCompare").textContent = price(
                    activeVariantPlan.compare_at_price * quantity
                );
                section.querySelector(
                    ".productPriceSavings"
                ).textContent = `Save ${Math.round(
                    ((activeVariantPlan.compare_at_price - activeVariantPlan.price) *
                        100) /
                    activeVariantPlan.compare_at_price
                )}%`;
            }
        }

        /**************
         ATC Enable/Disable
         ***************/

        if (section.querySelector(".productATCButton")) {
            // check if the variant is in stock
            if (activeVariant.available) {
                section.querySelector(".productATCButton").disabled = false;
                section.querySelector(".productATCButton").textContent = "Add To Cart";
            } else {
                section.querySelector(".productATCButton").disabled = true;
                section.querySelector(".productATCButton").textContent = "Sold Out";
            }
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch((e) => console.error(e));
    // Update prices on page load for default quantity
    updateBuyingOptionPrices(section);

    /**************
     Product Quantity
     ***************/

    // minus
    section
        .querySelectorAll(".productQuantityControlsBtn.minus")
        ?.forEach((element) => {
            element.addEventListener("click", function () {
                if (quantity === 1) return;
                quantity--;
                section
                    .querySelectorAll(".productQuantityControlsValue")
                    ?.forEach((element) => (element.textContent = quantity));
                updateProduct().catch((e) => console.error(e));
            });
        });

    // plus
    section
        .querySelectorAll(".productQuantityControlsBtn.plus")
        ?.forEach((element) => {
            element.addEventListener("click", function () {
                quantity++;
                section
                    .querySelectorAll(".productQuantityControlsValue")
                    ?.forEach((element) => (element.textContent = quantity));
                updateProduct().catch((e) => console.error(e));
            });
        });

    // Handle quantity selection changes and update prices
    section
        .querySelectorAll(".productQuantityValuesLabelInput")
        .forEach((input) => {
            input.addEventListener("change", function () {
                updateBuyingOptionPrices(section);
            });
        });

    /***********
     Sticky ATC
     ***********/

    const productContent = section.querySelector('.productInner');

    // sticky ATC height, adds to footer padding
    const stickyHeight = section.querySelector('.productATCFixed')?.offsetHeight || 0;
    // keep track of the position
    let position = window.scrollY;
    // keep track of how often called and provide a buffer for smoother experience
    let coolDown = false;
    // handle sticky ATC
    const updateSticky = () => {
        if (coolDown) return;
        const productBottom = productContent.getBoundingClientRect().bottom;
        // disappear on scroll up, prevents issues with mobile nav bars
        if (window.scrollY < position && window.innerWidth <= 500) {
            section.querySelector('.productATCFixed').style.top = '100dvh';
            document.querySelector('#footer').style.paddingBottom = '20px';
            // reset the position
            position = window.scrollY;
            return;
        }
        // if the main product section has scrolled off screen, apply active
        if (productBottom <= 0) {
            section.querySelector('.productATCFixed').style.top = `${100 - ((stickyHeight / window.innerHeight) * 100)}dvh`;
            document.querySelector('#footer').style.paddingBottom = `${stickyHeight + 20}px`;
        } else {
            section.querySelector('.productATCFixed').style.top = '100dvh';
            document.querySelector('#footer').style.paddingBottom = '20px';
        }
        // reset the position
        position = window.scrollY;
        // set slight pause
        coolDown = true;
        setTimeout(() => {
            coolDown = false;
        }, 300)
    }

    window.addEventListener('scroll', updateSticky, {passive: true});

    window.addEventListener("scroll", updateSticky, {passive: true});

    document
        .querySelector(".productStickyATCButton")
        ?.addEventListener("click", addProductToCart);

    /**************
     Product ATC
     ***************/

    document
        .querySelector(".productATCButton")
        ?.addEventListener("click", addProductToCart);

    // changing from OTP to Subscription
    document.querySelectorAll(".productBuyingOption").forEach((el) => {
        el.addEventListener("click", function () {
            // if the buying option is already active, return
            if (this.classList.contains("active")) return;

            this.closest(".productInner")
                ?.querySelectorAll(".productBuyingOption.active")
                ?.forEach((item) => {
                    // if the buying option doesn't match the data plan attribute, remove active class from each
                    if (item.dataset.plan !== el.dataset.plan) {
                        item.classList.remove("active");
                    }
                    // if the buying option matches the data plan attribute, add active class
                    section.querySelectorAll(".productBuyingOption")?.forEach((e) => {
                        if (e.dataset.plan === el.dataset.plan) {
                            e.classList.add("active");
                        }
                    });
                });
        });
    });

    section
        .querySelectorAll(".productContentInfoTitle")
        .forEach(function (element) {
            element.addEventListener("click", function () {
                if (this.classList.contains("active")) {
                    this.classList.remove("active");
                    return;
                }
                section
                    .querySelectorAll(".productContentInfoTitle.active")
                    .forEach(function (element) {
                        element.classList.remove("active");
                    });
                this.classList.add("active");
            });
        });
});

// Create a function to retrieve the active variant
function getActiveVariant() {
    // Get the product
    const product = JSON.parse(
        document.querySelector(".productJSON").textContent
    );

    // Get the options
    let options = Array.from(document.querySelectorAll(`.productOptionItem`))
        // Skip box option
        .filter(
            (optionGroup) =>
                optionGroup.querySelector("input:checked")?.getAttribute("name") !==
                "box"
        )
        // Skip options without a value
        .filter((optionGroup) =>
            optionGroup.querySelector("input:checked")?.getAttribute("value")
        )
        // map out checked options
        .map((optionGroup) => optionGroup.querySelector("input:checked")?.value);

    // Find the active variant
    const activeVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options);
    });

    return activeVariant || product.variants[0];
}

function getActiveVariantForATC() {
    // Get the product
    const product = JSON.parse(
        document.querySelector(".productJSON").textContent
    );

    // Get the options
    let options = Array.from(document.querySelectorAll(`.productOptionItem`))
        // Skip box option
        .filter(
            (optionGroup) =>
                optionGroup.querySelector("input:checked")?.getAttribute("name") !==
                "box"
        )
        // Skip options without a value
        .filter((optionGroup) =>
            optionGroup.querySelector("input:checked")?.getAttribute("value")
        )
        // map out checked options
        .map((optionGroup) => optionGroup.querySelector("input:checked").value);

    const quantityValue = document
        .querySelector(".productQuantityValuesLabelInput:checked")
        ?.getAttribute("data-option");
    // options = [options[0], quantityValue];

    // Find the active variant
    let activeVariant;
    if (options.length > 0) {
        activeVariant = product.variants.find(
            (variant) =>
                variant.option1 === options[0] && variant.option2.includes("1")
        );
    } else {
        activeVariant = product.variants.find((variant) => variant.option1 === 1);
    }

    return activeVariant || product.variants[0];
}

// Get all the product option item inputs
document.querySelectorAll(".productOptionItemValuesLabelInput").forEach(function (element) {
    // Create an event listener to update the label text
    element.addEventListener("change", function (e) {
        // Create a variable to store the corresponding label
        const correspondingLabel = document.querySelector(
            `.productOptionItem[data-option="${e.target.name}"] .productOptionItemLabelSelection`
        );

        // Exit if no corresponding label
        if (!correspondingLabel) {
            return;
        }

        // Update the corresponding labels text content to the selected value
        correspondingLabel.textContent = e.target.dataset.alt
            ? e.target.dataset.alt
            : e.target.value;

        // Create an event listener to update the active variant image
        if (element.getAttribute("name") === "flavor") {
            slideSwiperToActiveVariantImage();
        }
    });

});

// Create a function to slide the swiper to the active variant image
function slideSwiperToActiveVariantImage() {
    // Find the active variant
    const activeVariant = getActiveVariantForATC();

    if (document.querySelector(".productVisual.multiple")) {
        // hide existing active
        document.querySelector(".productVisualSwiper.active")?.classList.remove("active");
        // reveal matching media
        const optionName = activeVariant.option1.replace(" ", "-");
        document.querySelector(`.productVisualSwiper.${optionName}`).classList.add("active");
        document.querySelector(`.productVisualSwiper.${optionName}`).swiper.slideTo(0);
    } else {

        // If there is no featured image for the active variant exit
        if (!activeVariant.featured_image) {
            return;
        }

        // Get the product swiper
        const productSwiper = document.querySelector(".productVisualSwiper");

        // change active slide
        productSwiper.swiper?.slideTo(activeVariant.featured_image.position - 1);
    }

}

// create a function to get the selected quantity
function getSelectedQuantity() {
    const checkedQty = document.querySelector(
        ".productQuantityValuesLabelInput[name='variant_id']:checked"
    );

    if (!checkedQty) {
        return 1;
    }

    // Extract quantity from the label text or use a default
    const label =
        checkedQty.nextElementSibling?.querySelector(
            ".productQuantityValuesLabelSelectorTitle"
        )?.textContent || "1";

    // Try to extract numeric value from label (e.g., "Box of 30" -> 30)
    const match = label.match(/\d+/);
    return match ? parseInt(match[0]) : 1;
}

// create a function to get the selected selling plan
function getSelectedSellingPlan() {
    const selector = document.querySelector(".productSubscription.active .productSubscriptionSelector");

    if (!selector) {
        return null;
    }

    return parseInt(selector.getAttribute("selling_plan_id")) || null;
}

// Create a function to add the product to the cart
async function addProductToCart(e) {
    // update klaviyo item with variant information. we use a try catch since this would break if klaviyo is ever removed or disabled

    let activeVariant;
    try {
        const product = JSON.parse(
            document.querySelector(".productJSON").textContent
        );
        activeVariant = getActiveVariantForATC();
        item.Name = `${product.title} - ${activeVariant.title}`;
        item.URL = window.location.href;
        item.ImageURL = activeVariant.featured_image?.src;
        item.VariantID = activeVariant.id;
    } catch (e) {
    }

    // If the parameter was an event and the target contains the button class add the loading animation
    if (e instanceof Event && e.target.classList.contains("button")) {
        e.target.classList.add("loading");
    }

    const formData = {items: []};

    // Add items to form data
    formData.items.push({
        id: activeVariant.id,
        quantity: getSelectedQuantity(),
        selling_plan: getSelectedSellingPlan(),
    });

    // add product
    await addProduct(formData);

    // If the parameter was an event and the target contains the button class remove the loading animation
    if (e instanceof Event && e.target.classList.contains("button")) {
        e.target.classList.remove("loading");
    }

    // open cart
    await openCart();
}

// Create a function to update buying option prices based on selected quantity
function updateBuyingOptionPrices(section) {
    const checkedQty = section.querySelector(
        ".productQuantityValuesLabelInput[name='variant_id']:checked"
    );

    if (!checkedQty) {
        return;
    }

    // Get the price from the quantity selector
    const priceElement = checkedQty.nextElementSibling?.querySelector(
        ".productQuantityValuesLabelSelectorPrice"
    );

    if (!priceElement) {
        return;
    }

    const priceText = priceElement.textContent;
    // Extract numeric value from price text (e.g., "$30.00" -> 30.00)
    const priceMatch = priceText.match(/[\d.]+/);
    const price = priceMatch ? parseFloat(priceMatch[0]) : 0;

    // Update subscription box price (10% off = 0.9)
    const subscriptionPrice = price * 0.9;
    const subPriceReal = section.querySelector(
        ".productSubscription .productSubscriptionPriceReal"
    );
    const subPriceDose = section.querySelector(".subscriptionPricePerDose");

    if (subPriceReal) {
        subPriceReal.textContent = `$${subscriptionPrice.toFixed(2)} Per Box`;
    }

    if (subPriceDose && price > 0) {
        const servingsPerBox = 6;
        const pricePerServing = (subscriptionPrice / servingsPerBox).toFixed(2);
        subPriceDose.textContent = `$${pricePerServing}/serving`;
    }

    // Update OTP box price
    const otpPrice = section.querySelector(".productOTP .productOTPPrice");
    const otpPriceDose = section.querySelector(".OTPPricePerDose");

    if (otpPrice) {
        otpPrice.textContent = `${priceText} Per Box`;
    }

    if (otpPriceDose && price > 0) {
        const servingsPerBox = 6;
        const pricePerServing = (price / servingsPerBox).toFixed(2);
        otpPriceDose.textContent = `$${pricePerServing}/serving`;
    }
}

// check for url price for og price
const urlPrice = new URLSearchParams(window.location.search).get("price");
if (urlPrice) {
    // update og price
    const metaPrice = document.createElement("meta");
    metaPrice.setAttribute("property", "og:price:amount");
    metaPrice.setAttribute("content", `${parseFloat(urlPrice) / 100}`);
    document.head.appendChild(metaPrice);
}

// check for qty
const urlQty = new URLSearchParams(window.location.search).get("qty");
if (urlQty) {
    // click the quantity
    document.querySelectorAll(".productQuantityValuesLabel")[urlQty - 1]?.click();
}
